module.exports = __webpack_public_path__ + "img/ad.5b5fdf1c.png";